import { css } from '@emotion/css'
import { spacing, colors, zIndex, getThemeColors, fontFamily, fontSize } from '@offerzen/pinata-shame'

const styles = {
  container: css({
    position: 'fixed',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 14,
    borderBottom: `1px solid ${colors.mystic}`,
    top: 60,
    left: 0,
    right: 0,
    backgroundColor: colors.white,
    zIndex: zIndex.level5,
    fontFamily: fontFamily.body,
    lineHeight: 1.5,

    '& a': {
      textDecoration: 'none',
      color: colors.cornflowerBlue,
    },

    '& a:hover': {
      textDecoration: 'underline',
    },
  }),

  backButton: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: fontSize.small,
    color: getThemeColors('primary').base,
    marginRight: spacing.default,
  }),

  editButton: css({
    position: 'absolute',
    right: spacing.default,
    top: '50%',
    transform: 'translateY(-50%)',
  }),
}

export default styles
